module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    attrs: {
      "align": "left"
    }
  }, [_c('popup', {
    attrs: {
      "button-style": "primary",
      "heading": "Add Sites",
      "button-text": "Sites",
      "center-button": true,
      "disable-button": !_vm.isManager('project|maintenance|management'),
      "button-icon": "fa fa-broadcast-tower"
    },
    on: {
      "save": _vm.onSave,
      "close": _vm.onClose
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('select-site', {
    attrs: {
      "full-object": ""
    },
    model: {
      value: (_vm.site),
      callback: function($$v) {
        _vm.site = $$v
      },
      expression: "site"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [(_vm.site) ? _c('el-button', {
    staticStyle: {
      "margin-top": "67px"
    },
    attrs: {
      "type": "success",
      "size": "large"
    },
    on: {
      "click": _vm.unSelectedSites
    }
  }, [_vm._v("\n              >>\n            ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-table', {
    attrs: {
      "stripe": "",
      "border": "",
      "data": _vm.selected,
      "max-height": "528"
    },
    on: {
      "selection-change": _vm.selectedSitesCheck
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "52"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "siteId",
      "label": "Site ID",
      "width": "174"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "siteName",
      "label": "Site Name",
      "width": "528"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b1a6dc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/AddSitesOrg.vue
// module id = 1353
// module chunks = 0